import { Toaster } from "react-hot-toast";
import Router from "./routes";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-left"
        toastOptions={{
          style: {
            fontSize: "1.1rem",
            padding: "16px 24px",
            minWidth: "250px",
            fontFamily: "Noto Kufi Arabic, sans-serif",
          },
          success: {
            iconTheme: {
              primary: "#4ade80",
              secondary: "#f0fdf4",
            },
          },
          error: {
            iconTheme: {
              primary: "#f87171",
              secondary: "#fef2f2",
            },
          },
        }}
      />
      <Router />
    </div>
  );
}

export default App;